// removed by extract-text-webpack-plugin
module.exports = {"music":"_12hS","c":"nEiL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/music/index.less
// module id = 257
// module chunks = 0